import { SmartusComponentsModule } from '@affinis/smartus-components';
import { Component } from '@angular/core';
import { BreadcrumbService } from '@core/services/breadcrumb-service/BreadcrumbService';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SafeHtmlPipe } from '@shared/pipes';

@Component({
  selector: 'app-no-access',
  standalone: true,
  imports: [SmartusComponentsModule, TranslateModule, SafeHtmlPipe],
  templateUrl: './no-access.component.html',
  styleUrl: './no-access.component.scss',
})
export class NoAccessComponent {
  title: string = this.translateService.instant('no_access.title');
  message: string = this.translateService.instant('no_access.message');

  constructor(
    private breadcrumbService: BreadcrumbService,
    private readonly translateService: TranslateService
  ) {
    this.breadcrumbService.setBreadcrumbs([{ label: this.title }]);
  }
}
